<template>
  <div class="t-lk-modal__content t-lk-accept-modal">
    <h2 class="t-lk-modal__title">Принять</h2>
    <div class="t-lk-accept-modal__text">
      Спасибо за вашу готовность обработать запрос!
      Пожалуйста, свяжитесь с заказчиком по указанным в карточке контактным данным.
      По итогам обсуждения внесите договоренности о сроках возможной сделки в систему в течение 7 дней.
      Если вы перешли на стадию подписания договора, переведите лид в статус «выиграл».
      В случае потери интереса - укажите статус «Сделка не состоялась».
      В случае отсутствия действий с вашей стороны в течение 7 дней, лид будет передан другому партнеру, а ваша - репутация понижена.

      <a
        class="t-lk-modal__link"
        target="_blank"
        :href="faqLink"
      >
        Подробная информация
      </a>
    </div>

    <div class="t-lk-refuse-lead t-lk-modal__form">
    </div>

    <div class="t-lk-change-date__row">
      <div
        class="t-btn _green _lk"
        @click="acceptLead"
      >Принять</div>

      <div class="t-lk-change-date__close" @click="modalClose">
        {{ $root.staticText.lk.lkModalBtn }}
      </div>
    </div>


  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'accept-lead-modal',
  props: ['props'],
  computed: {
    ...mapGetters({
      modalPorops: 'modal/getModalProps'
    }),
    faqLink () {
      const isProd = process.env.NODE_ENV === 'production'
      return isProd 
        ? '/lk/faq/lidogeneratsiya'
        : '/lk/faq'
    }
  },
  methods: {
    ...mapActions({
      modalClose: 'modal/modalClose',
      lk_acceptLead: 'lk/leads/acceptLead',
    }),
    async acceptLead () {
      await this.lk_acceptLead(this.props.leadId)

      await this.props.acceptLeadHandler?.();
    }
  }
}
</script>

<style lang="sass">
.t-lk-accept-modal
  max-width: 450px

  &__text
    margin: 16px 0 24px;
    line-height: 150%;
    color: #4d556d;

  @media screen and (max-width: 920px)
      max-width: 100%

.t-lk-modal__link
  text-align: center
  margin-top: 24px
  width: 100%
  display: block
  text-decoration: underline
  color: #00b0bd
</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/accept-lead-modal.vue